import { createFileRoute, Link, Outlet, useLocation } from "@tanstack/react-router";
import { BookOpen, ChevronRight } from "lucide-react";
import { listBySection, PLAYBOOK_PAGES } from "@/lib/playbook-content";

export const Route = createFileRoute("/_authenticated/app/playbook")({
  component: PlaybookLayout,
});

function PlaybookLayout() {
  const loc = useLocation();
  const principles = listBySection("principles");
  const capabilities = listBySection("capabilities");
  const reference = listBySection("reference");

  const NavLink = ({ slug, title }: { slug: string; title: string }) => {
    const href = `/app/playbook/${slug}`;
    const active = loc.pathname === href;
    return (
      <Link
        to="/app/playbook/$"
        params={{ _splat: slug }}
        className={`block px-2 py-1 rounded text-xs hover:bg-accent ${active ? "bg-accent text-foreground" : "text-muted-foreground hover:text-foreground"}`}
      >
        {title}
      </Link>
    );
  };

  return (
    <div className="flex min-h-screen">
      <aside className="w-64 shrink-0 border-r bg-card p-4 hidden md:block">
        <Link to="/app/playbook" className="flex items-center gap-2 mb-4 font-semibold">
          <BookOpen className="h-4 w-4" /> Playbook
        </Link>

        <div className="space-y-4 text-sm">
          <Section title="Principles">
            {principles.map((p) => <NavLink key={p.slug} slug={p.slug} title={p.title} />)}
          </Section>
          <Section title="Capabilities">
            {capabilities.map((p) => <NavLink key={p.slug} slug={p.slug} title={p.title} />)}
          </Section>
          <Section title="Reference">
            {reference.map((p) => <NavLink key={p.slug} slug={p.slug} title={p.title} />)}
            <NavLink slug="GLOSSARY" title="Glossary" />
          </Section>
        </div>

        <div className="mt-6 text-[10px] text-muted-foreground">
          {PLAYBOOK_PAGES.length} pages · last verified Sprint 21
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <div className="px-2 py-1 text-[10px] uppercase tracking-wide text-muted-foreground flex items-center gap-1">
        <ChevronRight className="h-3 w-3" /> {title}
      </div>
      <div className="space-y-0.5">{children}</div>
    </div>
  );
}